import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UploadHistoryProvider } from '../../../../../contexts/UploadHistoryContext';
import { CardContent } from '../../../../../components/ui/card';
import CollapsibleCard from '../../../../../components/CollapsibleCard';
import MappedFields from '../../step3/MappedFields';
import ViewAdditionalFields from '../../views/ViewAdditionalFields';
import { viewUploadLog } from '../../../../../store/uploads/actions';
import { useNavigate, useParams } from 'react-router-dom';
import ReviewFormData from '../../step2/ReviewFormData';
import { format } from 'date-fns';

const Content = () => {
    const { key } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { viewLogData } = useSelector((state) => state.Uploads);

    const reviewFormData = [
        { label: 'Source Type:', value: viewLogData.sourceType },
        { label: 'Master Project:', value: viewLogData.masterProject },
        { label: 'Project:', value: viewLogData.project },
        { 
            label: viewLogData.sourceType === "Channel Partner" ? 'Channel Partner:': 'Vendor Name:',
            value: viewLogData.sourceType === "Channel Partner" ? viewLogData.channelPartner : viewLogData.vendor
        },
        { label: 'SPOC:', value: viewLogData.spoc },
        { label: 'Uploaded By:', value: viewLogData.uploadedBy },
        { label: 'Data Category:', value: viewLogData.dataCategory },
        { label: 'Lead Source:', value: viewLogData.leadSource },
        { label: 'Extracted On:', value: viewLogData.extractedOn ? format(viewLogData.extractedOn, 'MMMM do yyyy') : "" },
        { label: 'Reason of Procurement:', value: viewLogData.procReason }
    ];

    const passData = {
        pending: viewLogData.pending,
        file: viewLogData.file
    }

    useEffect(() => {
        if(key && !viewLogData._id){
            dispatch(viewUploadLog({key: key, navigate}))
        }
    }, [dispatch, key, navigate, viewLogData._id]);

    return (
        <>
            <CollapsibleCard 
                title="Review Upload Details"
                className="bg-white bg-opacity-100 mt-5"
                showCollapseButton={false}
                showBackButton={true}
                handleBack={() => navigate(-1)}
            >
                <CardContent>
                    <h5 className="font-semibold text-md text-primary-300 mb-5">
                        Please review the file details and additional fields below
                    </h5>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <div>
                            <ReviewFormData reviewFormData={reviewFormData} data={passData} />
                        </div>

                        <div className="grid grid-cols-1 gap-4 items-stretch">
                            <div className="col">
                                <MappedFields hideFieldSelection={true} hideNavigationButtons={true} />
                            </div>
                            <div className="col">
                                <ViewAdditionalFields />
                            </div>
                        </div>
                    </div>

                </CardContent>
            </CollapsibleCard>
        </>
    );
};

const ViewData = () => (
    <UploadHistoryProvider>
        <Content />
    </UploadHistoryProvider>
);

export default ViewData;
